import { createRouter } from '@tanstack/react-router'

import { queryClient } from '@/common/query/query-client'
import { storefrontConfig } from '@/common/storefront/storefront.config'

import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    storefront: storefrontConfig,
  },
  basepath: window.APP_ID
    ? `/zapps/${window.APP_ID}`
    : '/',
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  scrollToTopSelectors: ['.app-shell'],
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
